<template>
    <div class="container"> 
     <el-tag style="display:none" class="shopCss" v-loading="loading" element-loading-text="正在保存..." element-loading-spinner="el-icon-loading" >
                <p style="font-size:15px;color:#333;overflow-x:auto">店铺编码：<el-link style="color:#409EFF;font-size:17px;" @click="copyLink(shopCode)">{{shopCode}} </el-link>
                    <span class="shopStatus"  >店铺状态：<el-tag size="medium" :type="param.status==0?'danger':'success'">{{param.status==0?"封禁":"正常"}} </el-tag></span>
                    <el-button @click="$router.push('/shop')" style="margin-left:10px;display:none" icon="el-icon-lx-settings" type="primary" plain size="mini">店铺设置</el-button>
                   
                </p>
                <p style="color:#333;font-size:15px;margin-top:10px;">店铺链接：<el-link type="primary" class="shopLinkCss" style="overflow-x:auto;margin-right:20px;" :href="shopLink">{{shopLink}}</el-link>
                    <el-button @click="copyLink(shopLink)"  icon="el-icon-lx-copy" type="primary" plain size="mini">复制链接</el-button>
                    <el-button   icon="el-icon-lx-picfill" type="primary" plain size="mini">店铺海报</el-button>
                    <el-popover placement="right-start" transition="fade-in-linear" trigger="click" >
                        <div v-loading="loading" style="width: 150px; height: 150px">
                            <img style="width:150px;height:150px" :src="param.shopQR" />
                        </div>
                        <!--<el-button slot="reference" @click="showLink" style='margin-left:20px;' icon="el-icon-mobile-phone" type="primary" plain size="mini">扫码查看</el-button>
                        -->
                    </el-popover> 
                </p> 
                <input style="font-size:15px;border:none;opacity:0;" id="copy_content"  type="text" :value="param.shopLink">
            </el-tag>
        <el-row :gutter="0" style="margin-top:10px">
            <el-col class='pan1' style='padding:10px 10px 0px 10px'> 
                <p style='margin-bottom:10px;font-size:14px;'>累计订购</p>
                <el-row :gutter="4" class="mgb20" >
                    <el-col :span="12">
                        <el-card shadow="always cardSuccess ">
                            <div class="grid-con-1" > 
                                <div>上月订购</div><br><br>
                                <div class="grid-num">{{lookData.totalNum}}<span style="font-size:12px">人</span></div>  
                            </div>
                        </el-card>
                    </el-col> 
                </el-row>
                <el-row :gutter="4" class="mgb20" >
                    <el-col :span="4">
                        <el-card shadow="always cardSuccess ">
                            <div class="grid-con-1" > 
                                <div>上月订购</div><br><br>
                                <div class="grid-num">{{lookData.totalNum}}<span style="font-size:12px">人</span></div>  
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="4">
                        <el-card shadow="always cardSuccess ">
                            <div class="grid-con-1" > 
                                <div>本月订购</div><br><br>
                                <div class="grid-num">{{lookData.todayNum}}<span style="font-size:12px">人</span></div>  
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
                <el-row :gutter="4" class="mgb20">
                    <el-col :span="4">
                        <el-card shadow="always cardSuccess ">
                            <div class="grid-con-1" > 
                                <div>昨天订购</div><br><br>
                                <div class="grid-num">{{lookData.overMonthNum}}<span style="font-size:12px">人</span></div>  
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="4">
                        <el-card shadow="always cardSuccess ">
                            <div class="grid-con-1" > 
                                <div>今天订购</div><br><br>
                                <div class="grid-num">{{lookData.monthNum}}<span style="font-size:12px">人</span></div>  
                            </div>
                        </el-card>
                    </el-col>
                </el-row> 
                <el-card shadow="hover" style="height:265px;  "> 
                <el-row :gutter="4" class="mgb20" >
                      <schart ref="bar" class="schart1" canvasId="bar" :options="options"></schart> 
                </el-row>  
            </el-card> 
            </el-col> 
            <el-col class='pan1' style='padding:10px 10px 0px 10px'> 
                <p style='margin-bottom:10px;font-size:14px;'>累计失败：</p>
                <el-row :gutter="4" class="mgb20" >
                    <el-col :span="4">
                        <el-card shadow="always cardDanger ">
                            <div class="grid-con-1" > 
                                <div>上月失败</div><br><br>
                                <div class="grid-num" style='color:#fa5a5a'><span style="font-size:12px">￥</span>{{cashData.totalNum}}</div>  
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="4">
                        <el-card shadow="always cardDanger ">
                            <div class="grid-con-1" > 
                                <div>本月失败</div><br><br>
                                <div class="grid-num" style='color:#fa5a5a'><span style="font-size:12px">￥</span>{{cashData.todayNum}}</div>  
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
                
                <el-row :gutter="4" class="mgb20">
                    <el-col :span="4">
                        <el-card shadow="always cardDanger ">
                            <div class="grid-con-1" > 
                                <div>昨天失败</div><br><br>
                                <div class="grid-num"  style='color:#fa5a5a'><span style="font-size:12px">￥</span>{{cashData.overMonthNum}}</div>  
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="4">
                        <el-card shadow="always cardDanger ">
                            <div class="grid-con-1" > 
                                <div>今天失败</div><br><br>
                                <div class="grid-num"  style='color:#fa5a5a'><span style="font-size:12px">￥</span>111</div>  
                            </div>
                        </el-card>
                    </el-col>
                </el-row> 
            </el-col> 
            <el-col class='pan1' style='padding:10px 10px 0px 10px'> 
                <p style='margin-bottom:10px;font-size:14px;'>累计进单：</p>
                <el-row :gutter="4" class="mgb20" >
                    <el-col :span="4">
                        <el-card shadow="always cardInfo ">
                            <div class="grid-con-1" > 
                                <div>上月进单</div><br><br>
                                <div class="grid-num" style='color:#fa5a5a'><span style="font-size:12px">￥</span>{{cashData.totalNum}}</div>  
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="4">
                        <el-card shadow="always cardInfo ">
                            <div class="grid-con-1" > 
                                <div>本月进单</div><br><br>
                                <div class="grid-num" style='color:#fa5a5a'><span style="font-size:12px">￥</span>{{cashData.todayNum}}</div>  
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
                
                <el-row :gutter="4" class="mgb20">
                    <el-col :span="4">
                        <el-card shadow="always cardInfo ">
                            <div class="grid-con-1" > 
                                <div>昨天进单</div><br><br>
                                <div class="grid-num"  style='color:#fa5a5a'><span style="font-size:12px">￥</span>{{cashData.overMonthNum}}</div>  
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="4">
                        <el-card shadow="always cardInfo ">
                            <div class="grid-con-1" > 
                                <div>今天进单</div><br><br>
                                <div class="grid-num"  style='color:#fa5a5a'><span style="font-size:12px">￥</span>111</div>  
                            </div>
                        </el-card>
                    </el-col>
                </el-row> 
            </el-col>
            
            <el-col class='operIcon' style='padding:10px 10px 0px 10px;'>  
                <p style='margin-bottom:10px;font-size:14px;'>订购排行</p> 
                    <el-radio-group style='margin-top:-35px;float:right;' @change="getData" size='mini' v-model.trim="query.memFag" > 
                        <el-radio-button label="1">今日</el-radio-button>  
                        <el-radio-button label="2">昨日</el-radio-button> 
                        <el-radio-button label="3">本月</el-radio-button> 
                        <el-radio-button label="4">上月</el-radio-button> 
                        <el-radio-button label="4">全部</el-radio-button> 
                    </el-radio-group> 
                    <el-tooltip content="只显示打卡次数最多的20条数据" placement="top"> 
                    <el-table stripe border="false" style="margin-top:-15px;" :height="tableHeight" :data="orderMem" class="table"  ref="table" header-cell-class-name="table-header"   >
                        <el-table-column prop="id" min-width="50"   align="center" label="ID">
                            <template slot-scope="scope">
                                {{scope.$index+1}}
                            </template> 
                        </el-table-column>
                        <el-table-column prop="realName" min-width="180" align="left" label="会员信息"></el-table-column>
                        <el-table-column prop="orderNum" min-width="70" align="left" label="打卡天数"></el-table-column> 
                    </el-table>
                    </el-tooltip>
            </el-col>
            <el-col class='operIcon' style='padding:10px 10px 0px 10px; '> 
                <p style='margin-bottom:10px;font-size:14px;'>快捷操作</p>
                <el-row :gutter="4" class="mgb20" >
                    <el-col :span="3">
                        <el-card shadow="always"   class='pan-oper'>
                            <div class="grid-con-1" @click="$router.push('/messageManage')"> 
                                <center><i class='el-icon-lx-vipcard icon'></i> <br><br>   </center> 
                            </div>
                        </el-card>
                        <center><div class='div'>上游资源</div></center>
                    </el-col>    
                    <el-col :span="3">
                        <el-card shadow="always"  class='pan-oper'>
                            <div class="grid-con-1" @click="myMem"> 
                                <center><i class='el-icon-lx-peoplefill icon'></i> <br><br>   </center> 
                            </div>
                        </el-card>
                        <center><div class='div'>下游渠道</div></center>
                    </el-col>  
                    <el-col :span="3">
                        <el-card shadow="always"  class='pan-oper'>
                            <div class="grid-con-1" @click="$router.push('/goodsAdd')"> 
                                <center><i class='el-icon-lx-shop icon'></i> <br><br>   </center> 
                            </div>
                        </el-card>
                        <center><div class='div'>所有产品</div></center>
                    </el-col> 
                    <el-col :span="3">
                        <el-card shadow="always" class='pan-oper'>
                            <div class="grid-con-1" @click="$router.push('/orderMemberNav')"> 
                                <center><i class='el-icon-s-claim icon'></i> <br><br>   </center> 
                            </div>
                        </el-card>
                        <center><div class='div'>所有订单</div></center>
                    </el-col>  
                    <el-col :span="3">
                        <el-card shadow="always"   class='pan-oper'>
                            <div class="grid-con-1" @click="$router.push('/messageManage')"> 
                                <center><i class='el-icon-lx-vipcard icon'></i> <br><br>   </center> 
                            </div>
                        </el-card>
                        <center><div class='div'>我的文档</div></center>
                    </el-col>   
                     <el-col :span="3">
                        <el-card shadow="always"  class='pan-oper'>
                            <div class="grid-con-1"  @click="$router.push('/notice')"> 
                                <center><i class='el-icon-s-marketing icon'></i> <br><br>   </center> 
                            </div>
                        </el-card>
                        <center><div class='div'>我的下载</div></center>
                    </el-col> 
                   <el-col :span="3">
                        <el-card shadow="always" class='pan-oper'>
                            <div class="grid-con-1" @click="$router.push('/goodsList')"> 
                                <center><i class='el-icon-lx-goods icon'></i> <br><br>   </center> 
                            </div>
                        </el-card>
                        <center><div class='div'>我的消息</div></center>
                    </el-col>   
                    
                    <el-col :span="3">
                        <el-card shadow="always"  class='pan-oper' >
                            <div class="grid-con-1" @click="$router.push('/cashXhd')"> 
                                <center><i class='el-icon-lx-service icon'></i> <br><br>   </center> 
                            </div>
                        </el-card>
                        <center><div class='div'>我的待办</div></center>
                    </el-col> 
                    <!--<el-col :span="3">
                        <el-card shadow="always"  class='pan-oper'  >
                            <div class="grid-con-1" @click="$router.push('/woNav')"> 
                                <center><i class='el-icon-menu icon'></i> <br><br>   </center> 
                            </div>
                        </el-card>
                        <center><div class='div'>在线工单</div></center>
                    </el-col>   -->
                </el-row>  
            </el-col>
            <el-card shadow="hover" style="height:265px; "> 
                <p style='margin-bottom:10px;font-size:14px;'>转化率面板</p> 
                <el-button style='float:right;margin-top:-32px;' size='mini' @click='handleReadAll'>全部关闭</el-button> 
                <div class='overflowy' style="height:216px;overflow-y:scroll;scrollbar-width: none; -ms-overflow-style: none; ">
                <div v-if="mesData.length==0" style='text-align:center;margin-top:50px;'>暂无公告</div>
                <el-card v-for="item in mesData" shadow="always" >
                    <div class="grid-con-2" > 
                        <div style='position:relative;width:90%;'><el-tag type="warning" style='color:red;' @click='open(item)'>{{item.title}}</el-tag></div>  
                        <i @click="handleRead(item.$index,item.id)" style='font-size:15px;float:right;margin-top:-25px;' class='el-icon-close'></i>
                    
                        <div style='line-height:20px;font-size:13px;' @click='open(item)' v-html="item.content"> {{item.content}} </div>  
                    </div>
                </el-card> 
                </div> 
            </el-card>
            
            
             
            <el-card shadow="hover" style="height:265px;  "> 
                <el-row :gutter="4" class="mgb20" >
                      <schart ref="bar" class="schart1" canvasId="bar" :options="options"></schart> 
                </el-row>  
            </el-card> 
        </el-row> 
        <el-dialog :close-on-click-modal="false" title="更多信息" :visible.sync="moreVisible" width="300px">
                <span> {{text}} </span>
        </el-dialog>
        <!-- 新建绑定弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="添加会员" :modal-append-to-body='false' v-loading="loading" element-loading-text="正在初始化代理数据"  element-loading-background="rgba(0, 0, 0, 0.8)" :summary-method="getSummaries" show-summary   :visible.sync="addVisible"  center="true"  width="300px">
            <el-form ref="form1" :model="form" label-width="70px">
                <el-form-item label="真实姓名" >
                    <el-input  type="text" placeholder="真实姓名"  v-model.trim="form1.realName"   style="width:200px;" ></el-input>
                </el-form-item>
                <el-form-item label="会员等级" >
                    <el-select v-model.trim="form1.gid" @click="getGradeSelect" placeholder="代理等级" style="width:200px;" filterable  class="handle-select mr10"> 
                        <el-option v-for="item in select.option" :key="item.id" :label="item.gname" :value="item.id" />    
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input type="number" v-model.trim="form1.phone"  oninput ="value=value.replace(/[^\d]/g,'')" placeholder="登录账号" style="width:200px;"></el-input>
                </el-form-item>
                <!--<el-form-item label="验证码">
                    <el-input type="number"  v-model.trim="form1.code"  oninput ="value=value.replace(/[^\d]/g,'')" placeholder="验证码" style="width:100px;"></el-input>
                    <el-button  :type="sendSms.type" :disabled="sendSms.disabled" style="margin-left:10px;width:90px;" :style="sendSms.color"  @click="sendCode" >{{sendSms.content}}</el-button> 
                </el-form-item> -->
                <el-form-item label="初始密码">
                    <el-input v-model.trim="form1.loginPass"  placeholder="登录账号" style="width:200px;"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="alertDataNow.title" :modal-append-to-body='false'  :visible.sync="alertVisible" top="180px"  :width="width">
            <div style="margin-top:-20px;text-indent:30px" v-html="alertDataNow.content"></div>
             
            <span slot="footer" class="dialog-footer">
                <el-button type="error"  @click="readAll">全部已阅</el-button>
                <el-button type="error"  @click="read">已阅</el-button> 
                <el-button type="primary" @click="next">下一条</el-button>
            </span>
        </el-dialog>
        <div style="position:fixed;bottom:70px;right:50px;background:#fff;width:120px;height:130px;text-align:center;border:1px solid #eee;display:none">
            <p style="margin-top:5px;font-size:15px;">扫码下载app</p>
            <img  :src="app" alt="" style="width:100px;">
        </div>
    </div>
    
</template> 
<script>
import Schart from 'vue-schart';
import bus from '../common/bus';
import {getMemData,getMessage} from '../../api/dashBoard';
import {getPayInfo} from '../../api/cashApply';
import {updateData as updateDataMessage} from '../../api/message'; 
import { tableAutoScroll } from '../../api/autoScroll' 
import {fetchGradeSelect,saveForm} from '../../api/member'; 
import {updateData} from '../../api/message';  
export default {
    name: 'dashboard',
    data() {
        return { 
            orderMem:[],  
            tableHeight: 225,
            orderNum:[],
            cashData:[],
            lookData:[],
            text:'',
            index:'0',
            messNum:'0',
            app:require('/public/images/app.png') ,
            moreVisible:false,
            addVisible:false,
            alertVisible:false,
            loading:false,
            width:'320px',
            mid:'', 
            rid:'',
            stationId:'',
            shopCode:'',
            shopLink:'',
            query:{mid:'',stationId:'',memFag:'1',activeFag:'1'},
            select:{ option:'',  },
            avatar:'',
            mesData:[],
            alertData:[],
            alertDataNow:{},
            name: localStorage.getItem('ms_username'), 
            form1:{gid:''},
            form2:{},
            param:{},
            options: {
                bgColor:'#fff', 
                type: 'line',
                title: {
                    text: '近30天交易订单数'
                },
                smooth: true,//显示
                symbol: "circle",//折线节点为小圆点
                symbolSize: "5", //折线点大小 
                xRorate: 25,
                labels: ['8.26', '8.27','8.28', '8.29','8.30', '8.31', '9.1'],
                datasets: [
                    { 
                        data: [1, 0, 0, 0, 0,0,0]
                    }, 
                ]
            },
            options2: {
                type: 'bar',
                title: {
                    text: '团队订单'
                },
                labels: ['1月', '2月', '3月', '4月', '5月','6月', '7月', '8月', '9月', '10月','11月', '12月'],
                datasets: [
                    
                    { 
                        data: [7411, 118, 200, 235, 90, 74, 118, 200, 235, 90, 380, 180]
                    }
                ]
            }
        };
    },
    components: {
        Schart
    },
    mounted() {
        //this.avatar = localStorage.getItem('ms_avatar');
        //获取首页数据
        

        //this.iotInvest = "http://"+localStorage.getItem('iot_indexUrl')+"/iot/invest?st="+this.query.stationId; 
        setTimeout(() => {
            // 想要滚动就必须设置表格高度，这里设置的高度是100%，即跟父元素等高
            this.tableHeight = "225" 
            const table = this.$refs.table;
            tableAutoScroll(table);
        }, 50); 
        //查询系统消息 
        //获取下拉框数据
        //var path = this.$route.path;   
        //this.getData();   
        //this.getMessage();    
    }, 
    computed: {
         
    },
    // created() {
    //     this.handleListener();
    //     this.changeDate();
    // },
    // activated() {
    //     this.handleListener();
    // },
    // deactivated() {
    //     window.removeEventListener('resize', this.renderChart);
    //     bus.$off('collapse', this.handleBus);
    // },
    methods: { 
        //查询
        getData(){ 
            // 获取列表数据    
            getMemData(this.query).then(res => {  
                if(res.code=='200'){   
                    this.cashData = res.data.cashData;  
                    this.lookData = res.data.lookData;  
                    this.orderMem = res.data.orderMem;  
                    this.options.labels = res.data.myOrderTime;
                    this.options.datasets[0].data = res.data.myOrderNum; 
                } 
            });
        },
         goShop(){
            window.open("http://"+localStorage.getItem('ms_indexUrl') +"/hk/index?st="+localStorage.getItem('ms_stationId')+"&sc="+localStorage.getItem('ms_shopCode') );
        },
        //获取下拉框数据
        getGradeSelect(){ 
            this.select.mid = this.query.mid;
            this.select.stationId = this.query.stationId;
            fetchGradeSelect(this.select).then(res => {  
                if(res.code=='200'){ 
                    this.select.option = res.data.list; 
                    this.form1.gid = res.data.list[0].id; 
                }
            });
        },
        numFilter(value) { 
            const realVal = parseFloat(value).toFixed(2); 
            return realVal; 
        },
        changeDate() {
            const now = new Date().getTime();
            this.data.forEach((item, index) => {
                const date = new Date(now - (6 - index) * 86400000);
                item.name = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
            });
        }, 
        // 新增代理
        addBind() { 
            if(this.rid==7){
                this.$message.error("对不起，您暂无分销权限，请联系客服助理开通！");
                return;
            }
            this.addVisible = true;
        },
        myMem(){
            
            this.$router.push('/members')
        },
        //保存新增
        saveForm() {  
            this.form1.fid = localStorage.getItem('ms_fid');
            this.form1.mid = this.query.mid;
            this.form1.stationId = this.query.stationId; 
            if( !this.form1.realName ){
                this.$message.error("请填写真实姓名");
                return;
            }
            if( !this.form1.gid ){
                this.$message.error("请选择代理等级");
                return;
            } 
            if( !this.form1.phone  ){
                this.$message.error("请填写手机号");
                return;
            }
            if( this.form1.phone.length!=11  ){
                this.$message.error("手机号长度不正确！");
                return;
            }
            /*if( !this.form1.code){
                this.$message.error("请输入验证码");
                return;
            }
            if( this.form1.code != this.sendSms.code){
                this.$message.error("验证码不正确");
                return;
            } */
            if( !this.form1.loginPass){
                this.$message.error("请输入初始密码");
                return;
            }  
            
            this.loading = true;
            this.addVisible = false;
            this.form1.avatar = this.avatar;
            saveForm(this.form1).then(res => {
                this.loading = false; 
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData(this.query);
                }else{
                    this.$message.error(res.message); 
                } 
            });
        },
        copyLink(text){   
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);  
            //提示已复制
            this.$message.success("复制成功"); 
           
        },
       
        handleRead(index,id) {
            let param = {};
            param.id=id; 
            param.messageType='1'; 
            param.stationId = this.query.stationId,
            param.status='0';
            param.delFag='';
            updateData(param).then(res => {  
                if(res.code=='200'){  
                    const item = this.mesData.splice(index, 1);   
                }else{
                    this.$message.error(res.message);
                }
                
            }); 
        }, handleReadAll() {   
            this.mesData = [];
            let param = {};
            param.messageType='1'; 
            param.stationId = this.query.stationId,
            param.status='0';
            param.delFag=''; 
            updateDataMessage(param).then(res => {   
                if(res.code=='200'){  
                    this.mesData = [];  
                }else{
                    this.$message.error(res.message);
                }
                
            });
        },
        
        open1(){
            this.$router.push('/userAccess');
        },
        open2(){
            this.$router.push('/message');
        },
        open3(){
            this.$router.push('/orderIndex');
        },
        getMessage(){
            // 获取消息数据     
            getMessage(this.query).then(res => {  
                if(res.code=='200'){ 
                     
                    this.mesData = res.data.list1;  
                    this.alertData = res.data.list2;     
                    this.messNum = this.alertData.length;
                    if(this.alertData && this.messNum>0){ 
                        if(document.body.offsetWidth<600 ){
                            this.width="330px";  
                        }else{
                            this.width="520px"; 
                        } 
                        this.alertDataNow = this.alertData[0];
                        this.alertVisible = true;
                    }
                }
            });
        },
        read(){
            let param = {};
            param.id=this.alertData[this.index].id; 
            param.stationId = this.query.stationId,
            param.messageType='9'; 
            param.status='0';
            param.delFag='';
            updateData(param).then(res => {  
                if(res.code!='200'){  
                    this.$message.error(res.message);
                }
                
            });
            this.index++;
            if(this.index==this.messNum){
                this.alertVisible = false;
                this.$message("暂无更多消息");
            }else{ 
                this.alertDataNow = this.alertData[this.index]; 
            }  
        }, 
        readAll(){
            this.alertVisible = false;
            let param = {};
            param.id=''; 
            param.messageType='9'; 
            param.stationId = this.query.stationId,
            param.status='0';
            param.delFag='';
            updateData(param).then(res => {   
                if(res.code=='200'){  
                    const item = this.unread;
                    this.read = item.concat(this.read); 
                    this.unread = ''; 
                }else{
                    this.$message.error(res.message);
                }
                
            });
        },
        next(){
            this.index++;
            if(this.index==this.messNum){
                this.alertVisible = false;
                this.$message("暂无更多消息");
            }else{ 
                this.alertDataNow = this.alertData[this.index]; 
            } 
        },
       
        //展开消息
        open(row,i){ 
             this.$alert(row.content,row.title,{ 
                dangerouslyUseHTMLString: true,  
                showConfirmButton:false,  
                center: false,  
                lockScroll:false,
            })  

           /* var time = 2500;
            if(row.content.length>30 && row.content.length<50 ){
                time = 3500;
            }else if(row.content.length>49 && row.content.length<100 ){
                time = 5000;
            }else if(row.content.length>99 ){
                time = 10000;
            } 
            time = 10000000;
            this.$notify({
                title: row.title,
                dangerouslyUseHTMLString: true,
                message: row.content,
                duration:time,
                offset: 120*i+100,   
                
            }); */
        }, 
        // handleListener() {
        //     bus.$on('collapse', this.handleBus);
        //     // 调用renderChart方法对图表进行重新渲染
        //     window.addEventListener('resize', this.renderChart);
        // },
        // handleBus(msg) {
        //     setTimeout(() => {
        //         this.renderChart();
        //     }, 200);
        // },
        // renderChart() {
        //     this.$refs.bar.renderChart();
        //     this.$refs.line.renderChart();
        // }
    }
};
</script> 
<style>

.el-dialog__title{
    font-size:15px;
    font-weight:700;
    padding-right:25px; 
    display: inline-block;
}
.el-dialog--center .el-dialog__body{
    padding: 15px 15px 20px;
}
.el-dialog__body{
    padding: 20px;
} 
.el-dialog__footer{
    padding:0 20px 10px;
}

element.style {
    z-index: 2001;
}
 
.el-carousel__arrow--right, .el-notification.right {
    right: 50%;
    margin-right: -230px;
}
.el-notification{
    padding: 9px 16px 9px 5px;
    position: absolute;
    margin-top: -80px;
    width:460px;
}
.el-table tr { 
    font-size: 14px;
}
.icon{
    font-size:40px;
    color:#409EFF;
}
.icon {
    color: #409EFF;
    background-image: -webkit-linear-gradient(90deg, #409EFF, #f41392);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-animation: change 5s infinite linear;
  }
@-webkit-keyframes change {
    from {
      -webkit-filter: hue-rotate(0deg);
    }
    to {
      -webkit-filter: hue-rotate(-360deg);
    }
} 
.div{
    font-size:15px;
    margin-top:5px;  
}
.grid-num {
        /* //   内联元素（inline）动画不起作用， 因此要设置为‘inline-block’ */
        display: inline-block;
        animation: jump 2s infinite ease-in-out;
        animation-delay: var(--delay);
      }

      @keyframes jump {
        0%,
        100% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(-10px);
        }
      } 
  
@media screen and (max-width:768px){
    .el-card {
        border:1px solid #EBEEF5;
    }
     .operIcon{
        
    }
    .pan-oper{
        height:65px; 
    }
    .el-col-3 { 
        width:25%;
    }
    .el-row {
        margin-bottom: 10px;
    }
   
    .el-col-4 { 
        width: 50%;
    } 
    .el-card__body, .el-main{
        padding:15px ;  
        line-height:12px;
    }
    .grid-con-icon {
        display:inline-block;
        font-size: 30px;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        color: #fff;
    }
    .grid-content {
        display: flex;
        align-items: left;
        height: 50px;
    } 
    .grid-num {
        font-size: 20px;
        font-weight: bold;
    }
    .grid-cont-right {
        flex: 1;
        text-align: center;
        font-size: 12px;
        color: #999;
    }
    .user-info {
        display: flex;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 2px solid #ccc;
        margin-bottom: 20px;
    }

    .user-avator {
        width: 60px;
        height: 60px;
        border-radius: 50%;
    }

    .user-info-cont {
        padding-left: 50px;
        flex: 1;
        font-size: 14px;
        color: #999;
    }

    .user-info-cont div:first-child {
        font-size: 25px;
        color: #222;
    }
    .shopCss{
        width:100%;min-height:160px;padding:5% 2%;
        background:#ecf5ff !important;
    }
    .shopStatus{  
        color:#333;font-size:15px;margin:10px 0;margin-left:15px;
    }
    .shopLinkCss{
        display:block;
        height:35px;
        line-height:35px;
        color:blue;font-size:13px;
    }
}
@media screen and (min-width:768px){
    .el-card {
        border:none;
    }
    .shopCss{
        width:100%;height:90px;padding:1% 2%;
        background:#ecf5ff !important;
    }
    .shopStatus{
        color:#333;font-size:15px;margin:10px 0;margin-left:30px;
    }
    .shopLinkCss{
        color:blue;font-size:17px;
    }
    .pan1{
        display: inline-block;
        width:33%;
        padding:35%;
        box-shadow: 0px 0px 5px 5px #eee; 
    }
    .pan-oper{
        height:65px
    }
    .btnIcon{
        margin-top:20px;
    }
    .operIcon{
        width:420px;
    }
    .el-col-3 { 
        min-width: 100px;
        padding: 6px 2px;
    }
    .el-card__body, .el-main{
        padding:15px 10px 10px 10px; 
        line-height:15px; 
    }
    .el-col-4 { 
        width: 160px;
    } 
    .el-row {
        margin-bottom: 30px; 
    }
    .grid-con-icon {
    display:inline-block;
    font-size: 50px;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    color: #fff;
    }
    .grid-content {
    display: flex;
    align-items: center;
    height: 100px;
    } 
    .grid-num {
    font-size: 20px;
    font-weight: bold;
    }
    .grid-cont-right {
    flex: 1;
    text-align: center;
    font-size: 14px;
    color: #999;
    } 
    .user-info {
        display: flex;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 2px solid #ccc;
        margin-bottom: 20px;
    } 
    .user-avator {
        width: 120px;
        height: 120px;
        border-radius: 50%;
    }
     
    .user-name{ 
        font-size:15px; 
    }
    .user-info-cont {
        padding-left: 50px;
        flex: 1;
        font-size: 14px;
        color: #999;
    }

    .user-info-cont div:first-child {
        font-size: 30px;
        color: #222;
    }   
}



 
.grid-con-1 .grid-con-icon {
    background: rgb(45, 140, 240);
}

.grid-con-1 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-2 .grid-con-icon {
    background: rgb(100, 213, 114); 
}

.grid-con-2 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-3 .grid-con-icon {
    background: rgb(242, 94, 67);
}

.grid-con-3 .grid-num {
    color: rgb(242, 94, 67);
}



.user-info-list {
    font-size: 14px;
    color: #999;
    line-height: 25px;
}

.user-info-list span {
    margin-left: 70px;
}

.mgb20 {
    margin-bottom: 20px;
}

.todo-item {
    font-size: 14px;
}

.todo-item-del {
    text-decoration: line-through;
    color: #999;
}
.schart1 {
    width: 100%;
    height: 235px; 
}
.schart {
    width: 100%;
    height: 265px;
}
.schart2 {
    width: 100%;
    height: 465px;
}
</style>
